export const passwordValidation = (password: string): boolean => {
  const regex =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
  return regex.test(password);
};

export const usernameValidation = (username: string): boolean => {
  const regex = /^(?!.*[_.]{2})(?![_.])[a-zA-Z0-9._]{3,30}(?<![_.])$/;
  return regex.test(username);
};
